/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, themeV2 } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- DIMENSIONS FORM : STYLES --------------- ++++++++++ */
export default theme => ({
    deliverySettings:{
        marginTop: pxToEm(16),
        margin: themeV2.spacing[2],
        background: 'white',
        borderRadius: pxToEm(5),
        marginLeft: pxToEm(-8),
        '& .toggle': {
            marginLeft: 0,
            marginRight: pxToEm(15),
        },
        '& .name-format': {
            display: 'flex'
        },
        '& .name-daypickers': {
            display: 'flex',
            alignItems: 'center',
            marginRight: pxToEm(15),
            marginBottom: pxToEm(15),
            '& .singleselectdropdown': {
                marginRight: pxToEm(10),
                height: '3.5em !important',
            }
        },
        '& .formelement': {
            border: '1px solid rgb(238, 242, 246)',
            borderRadius: pxToEm(12),
            padding: pxToEm(10),
            height: pxToEm(48),
            display: 'flex',
            alignItems: 'center',
            maxWidth: '33em',
            background: themeV2.color.base.white,

            '& input.textfield': {
                padding: 0,
                background: 'none',
                width: '100%',
                outline: 'none',
                fontSize: pxToEm(16),
                color: themeV2.color.primary.main,
                fontWeight: '300',
                border: "none",
                '&::placeholder': {
                    color: "#7E92B8",
                    fontFamily: "Work Sans",
                    fontSize: pxToEm(16),
                    fontStyle: "normal",
                    fontWeight: 500,
                    lineHeight: pxToEm(22),
                },
            },
        },
        '& .name-searchemail': {
            display: 'flex',
            alignItems: 'center',
            marginRight: pxToEm(15),
            '& .name-menuItems': {
                padding: 0
            }
        },
        '& .name-frequency': {
            display: 'flex',
            alignItems: 'center',
            marginRight: pxToEm(15),
            marginBottom: pxToEm(15),
        },
        '& .dropDownItem': {
            paddingLeft: pxToEm(15),
        }
    },
    emailRow: {
        display: 'flex',
        alignItems: 'center',
        padding: pxToEm(15),
        paddingLeft: 0,
        '& i': {
            paddingLeft: pxToEm(5),
        }
    },
    emailAvatar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: pxToEm(5),
        padding: pxToEm(15),
        width: pxToEm(15),
        height: pxToEm(15),
        borderRadius: '50%',
        '& p': {
            fontSize: themeV2.typography.size.xxsmall.fontSize,
            color: 'white'
        }
    },
    emailText: {
        fontSize: themeV2.typography.size.xsmall.fontSize,
    },
    deliverySummaryMessage: {
        padding: pxToEm(15),
        borderRadius: pxToEm(5),
        paddingTop : pxToEm(0),
    },
    addNewEmail: {
        padding: pxToEm(8),
        paddingLeft : pxToEm(12),
        display: 'flex',
        alignSelf: 'baseline',
        '& span': {
            paddingLeft: pxToEm(5),
        },
        '& > button': {
            borderRadius: pxToEm(12),
            background: "#061240 !important",
            height: pxToEm(48),
            color: "#FFF !important",
            textAlign: 'center',
            fontFamily: "Work Sans",
            fontSize: pxToEm(16),
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: pxToEm(24),
            width: 'auto !important',
            padding: '0px 16px !important',
            '& > .text': {
                padding: '0px !important',
            }
        }
    },
    errorText: {
        fontSize: pxToEm(14),
        color: themeV2.color.error.main,
        paddingTop: pxToEm(5),
    },
    recepientEmail: {
        marginTop: pxToEm(24),
        paddingLeft: pxToEm(24),
        borderLeft : '2px solid #AFBCD5',
    },
    emailTitle : {
        color: "#061240",
        fontFamily: "Work Sans",
        fontSize: pxToEm(14),
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: pxToEm(18),
    },
    frequencySection :{
        marginTop: pxToEm(24),
        color: "#061240",
        fontFamily: "Work Sans",
        fontSize: pxToEm(14),
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: pxToEm(18),
        '& > .group': {
            marginTop: pxToEm(10),
            '& > .control': {
                borderRadius: pxToEm(12),
                border: '2px solid #061240'
            },
            '& > .selected-true': {
                border: '3px solid #3257EC',
                borderRadius: '12px !important',
                '& .checkmark':{
                    '& span':{
                        '& i':{
                            color: '#3257EC',
                        }
                    }

                }
            }
        }
    },
    sendDate:{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: pxToEm(8),
        '& > span': {
            color: "#061240",
            "font-variant-numeric": "lining-nums proportional-nums",
            fontFamily: "Work Sans",
            fontSize: pxToEm(14),
            fontStyle: 'normal',
            fontWeight: 400,
        }
    },
    endDate:{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: pxToEm(8),
        '& > span': {
            color: "#061240",
            "font-variant-numeric": "lining-nums proportional-nums",
            fontFamily: "Work Sans",
            fontSize: pxToEm(14),
            fontStyle: 'normal',
            fontWeight: 400,
        }
    },
    dayPickerSection : {
        borderLeft: "2px solid #AFBCD5",
        paddingLeft: pxToEm(24),
    },
    '@global': {
        'MuiSwitch-root' : {
            'MuiButtonBase-root' : {
                '.MuiSwitch-thumb': {
                    color: '#FFFFFF'
                }

            }
        }
    }
});
